'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

require('./Form.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FORM_PROPS = [
// HTML attributes
'action', 'autoComplete', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'noValidate', 'novalidate', 'target',
// Event listeners
'onChange', 'onInput', 'onSubmit'];

var Form = function Form(props) {
    return _react2.default.createElement(
        'form',
        _extends({}, (0, _lodash.pick)(props, FORM_PROPS), { className: (0, _classnames2.default)('Form', props.className) }),
        props.children
    );
};

Form.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element])
};

exports.default = Form;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/Form.js
// module id = 138
// module chunks = 0